import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ProfileView from '../components/views/Profile';
import { getUsersProjects } from '../helpers';
import { withRouter } from '../helpers/withRouter';
import { bulkSetVacations, closeModal, editProject, editUser, openModal } from '../redux/actions';
import type {
  ProfileProps, Project, SingleModalState, State as StoreState, User, VacationsPayload
} from '../types';

class Profile extends Component<ProfileProps> {
  render(): React.ReactNode {
    return (
      <ProfileView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  projects: _.sortBy(getUsersProjects(state.currentUser, state.projects.items), 'title'),
  currentUser: {
    ...state.currentUser,
    ..._.find(state.users, { id: state.currentUser.id }), // on update own profile we need updated info
  },
  holidays: state.holidays,
  vacations: state.vacations[state.currentUser.id],
});

const mapDispatchToProps = dispatch => ({
  onEditUser: (user: User) => dispatch(editUser(user)),
  onEditProject: (project: Project) => dispatch(editProject(project)),
  onBulkSetVacations: (userId: number, year: number, vacations: VacationsPayload) => dispatch(bulkSetVacations(userId, year, vacations)),
  onOpenModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  onCloseModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
});

const ConnectedProfile = withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile as any))

export default ConnectedProfile;
